module.exports = __webpack_public_path__ + "static/media/vegitables_62.f5a8ee92.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_62.csv
// module id = 649
// module chunks = 0